import { Icon } from '@components/icon/Icon';
import { useHandleClickOutside } from '@shared/hooks/useHandleClickOutside';
import { appendGuestCountLabel } from '@utils/guestCount';
import cx from 'classnames';
import type { ReactNode } from 'react';
import typography from '~styles/typography.scss';
import styles from './GuestCountFilterPill.scss';

export interface GuestCounterFilterPillProps {
  closeFilter: () => void;
  isOpenFilter: boolean;
  onFilterOpen?: () => void;
  openFilter: () => void;
  selectedGuestCount: number;
  popover: ReactNode;
  className?: string;
  showGuestsLabel?: boolean;
}

export const GuestCountFilterPill = ({
  closeFilter,
  isOpenFilter,
  onFilterOpen,
  openFilter,
  selectedGuestCount,
  popover,
  className,
  showGuestsLabel = false,
}: GuestCounterFilterPillProps) => {
  const togglePopoverVisibility = () => {
    if (isOpenFilter) {
      closeFilter();
    } else {
      openFilter();
      if (onFilterOpen) onFilterOpen();
    }
  };

  const { ref } = useHandleClickOutside(closeFilter);

  const pillClassNames = cx(typography.t1, styles.pill, className, {
    [styles.isOpen]: isOpenFilter,
  });

  const ariaLabel = `${appendGuestCountLabel(
    selectedGuestCount,
  )}. Filter by guest count`;

  const guestsLabel = selectedGuestCount === 1 ? 'Guest' : 'Guests';

  return (
    <div ref={ref}>
      <button
        type="button"
        aria-label={ariaLabel}
        className={pillClassNames}
        onClick={togglePopoverVisibility}
      >
        <Icon className={styles.icon} name="couple" />

        <span className={cx(typography.t1, styles.guestCount)}>
          {selectedGuestCount}
        </span>

        {showGuestsLabel && (
          <span className={cx(typography.t1)}>{guestsLabel}</span>
        )}
      </button>

      {isOpenFilter && popover}
    </div>
  );
};
